import React, { useState } from "react";
import { Input, DatePicker, Tag, Select, Button, message } from "antd";
import ModalWrapper from "../../Modal";
import dayjs from "dayjs";
import { postRequest } from "../../service/index";

const { TextArea } = Input;

const AddInventoryModal = ({ open, onRequestClose }) => {
    const initialFormData = {
        productName: "",
        quantity: "",
        productType: "",
        price: "",
        purchaseDate: null,
        serialNos: [],
        description: "",
    };
    const [formData, setFormData] = useState(initialFormData);

    // For Select (serialNos) - keep in sync with formData
    const handleSerialNosChange = (value) => {
        setFormData((prev) => ({
            ...prev,
            serialNos: value,
        }));
    };

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = async () => {
        // Prepare data for API (format date as string if needed)
        const dataToSend = {
            ...formData,
            purchaseDate: formData.purchaseDate
                ? dayjs(formData.purchaseDate).format("YYYY-MM-DD")
                : null,
        };
        try {
            const response = await postRequest("/api/inventory", dataToSend);
            if(response.message=="Inventory item created successfully")
            {
                message.success("Inventory added successfully!");
                setFormData(initialFormData);
                onRequestClose();
            }
            else
            {
                message.error(response.error || "Inventory not added")
            }
        } catch (error) {
            message.error("Failed to add inventory:", error);
        }
    };

    return (
        <ModalWrapper title="Inventory" open={open} onRequestClose={onRequestClose}>
            <div className="flex flex-col gap-4">
                <div className="max-h-[60vh] overflow-y-auto px-2">
                    <div>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="col-span-2">
                                <label className="block mb-1">Product Name</label>
                                <Input
                                    placeholder="Enter product name"
                                    value={formData.productName}
                                    onChange={e => handleInputChange("productName", e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block mb-1">Quantity</label>
                                <Input
                                    type="number"
                                    min={1}
                                    placeholder="Enter quantity"
                                    value={formData.quantity}
                                    onChange={e => handleInputChange("quantity", e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block mb-1">Product Type</label>
                                <Input
                                    placeholder="Enter product type"
                                    className="w-full"
                                    value={formData.productType}
                                    onChange={e => handleInputChange("productType", e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block mb-1">Price</label>
                                <Input
                                    type="number"
                                    min={0}
                                    placeholder="0"
                                    value={formData.price}
                                    onChange={e => handleInputChange("price", e.target.value)}
                                />
                            </div>
                            <div>
                                <label className="block mb-1">Purchase Date</label>
                                <DatePicker
                                    className="w-full"
                                    value={formData.purchaseDate}
                                    onChange={date => handleInputChange("purchaseDate", date)}
                                />
                            </div>
                            <div className="col-span-2">
                                <label className="block mb-1">Serial No</label>
                                <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    placeholder="Enter serial numbers and press Enter"
                                    value={formData.serialNos}
                                    onChange={handleSerialNosChange}
                                    tokenSeparators={[',']}
                                />
                                <div className="mt-2 flex flex-wrap gap-1">
                                    {formData.serialNos.map((sn, idx) => (
                                        <Tag key={idx} color="blue">{sn}</Tag>
                                    ))}
                                </div>
                            </div>
                            <div className="col-span-2">
                                <label className="block mb-1">Description</label>
                                <TextArea
                                    placeholder="Write description about product..."
                                    rows={4}
                                    value={formData.description}
                                    onChange={e => handleInputChange("description", e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button onClick={onRequestClose}>Cancel</Button>
                    <Button
                        type="primary"
                        onClick={handleSave}
                        className="bg-primary hover:bg-primary/80"
                    >
                        Save
                    </Button>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default AddInventoryModal;